import { useTranslation } from "react-i18next"
import Loader from "../../../../../../../../components/loader"
import { ScrollContainer } from "../../../../../../../../components/scrollContainer"
import { useStyles } from "./styles"
import { Box, Button, Pagination, SxProps, Typography } from "@mui/material"
import { NoResponse } from "../../../../../../../../components/errors/noResponse"
import { DestinatiosListProps } from "./types"
import { DestinationAccordion } from "../destination"


export const DestinationsList = ({ destinationsList, changeExpandMap, displayDestination, usersToView, hiddeAll, seeAll, manualPagination, loading, expandMap, menuOption }: DestinatiosListProps) => {
    const { t } = useTranslation()
    const styles = useStyles()
    return (
        <>
            {!!loading && <Loader />}

            {
                !loading && (
                    <>
                        <Box sx={styles.container}>
                            <Box sx={{ ...styles.alignHorizontal, ...styles.wFull } as SxProps}>
                                <Box sx={styles.header}>
                                    <Typography variant="title_grey_big">{t('loogbook.titles.destinationsList')}</Typography>

                                    <Box sx={styles.allButons}>
                                        <Button sx={styles.seeButons} onClick={seeAll}>{t('loogbook.buttons.seeAll')}</Button>
                                        <Button sx={styles.seeButons} onClick={hiddeAll}>{t('loogbook.buttons.hiddenAll')}</Button>
                                        {!expandMap && <Button sx={styles.seeButons} onClick={changeExpandMap}>{expandMap ? t('loogbook.buttons.hiddenMap') : t('loogbook.buttons.seeMap')}</Button>}
                                    </Box>
                                </Box>

                            </Box>
                            <ScrollContainer maxHeight="600px" sx={styles.list}>
                                {
                                    destinationsList && destinationsList.map(destination => (<>
                                        <DestinationAccordion
                                            companyName={destination.companyName}
                                            createdDate={destination.createdDate}
                                            direction={destination.direction}
                                            id={destination.id}
                                            latitudeAndLongitude={destination.latitudeAndLongitude}
                                            name={destination.name}
                                            userCreator={destination.userCreator}
                                            displayDestination={displayDestination}
                                            isVisible={usersToView.some(item => (item == destination.id))}
                                            key={destination.id}
                                            mapExpanded={expandMap}
                                            companyId={destination.companyId}
                                            menuOption={menuOption}
                                            storeId={destination.storeId}
                                        />
                                    </>))
                                }
                                {!destinationsList.length && <NoResponse label={t('general.noDestinations')} />}
                            </ScrollContainer>
                            <Box sx={styles.footer}>
                                <Pagination
                                    page={manualPagination.page}
                                    sx={styles.pagination}
                                    count={manualPagination.totalPages}
                                    onChange={(_, page) => {
                                        manualPagination.changePagination({ page, })
                                    }}
                                    showFirstButton
                                    showLastButton
                                />
                            </Box>
                        </Box>
                    </>
                )
            }



        </>
    )
}